import { BlankUnit } from "./types";

export const statuses = [
  { value: false, label: "Available" },
  { value: true, label: "Occupied" }
];

export const unitStatus = (occupied: boolean) =>
  occupied ? "Occupied" : "Available";

export const blankUnit: BlankUnit = {
  unitName: "",
  rentAmount: null,
  homeRentAmount: null,
  siteRentAmount: null,
  occupied: false,
  available_at: new Date().toISOString().split("T")[0],
  external_id: ""
};
